// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "5fa55d07" + "." + "addd40de08ab623d" + ".js";
};